import DOMPurify from "dompurify";
import React, { MouseEvent } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { jsx } from "slate-hyperscript";
import {
    BlockDeserializer,
    ElementRenderer,
    ElementSettings,
    InlineHandler, StyleType, TextElement,
} from "./base";

interface LinkSettings extends ElementSettings {
    url?: string;
    onClick?: (evt: MouseEvent) => void;
    linkAttributes?: Record<string, string>;
}

InlineHandler.register(StyleType.LINK, {
    nodeTypes: ["A"],
    toBlock: (child, settings) => (
        <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={props => (
                <Popover
                    className="popover-no-arrow text-gray-200 bg-blue-dark p-2 m-0 rounded"
                    id="pop-link"
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...props}
                    arrowProps={{ style: { display: "none" } }}
                >
                    {settings.url}
                </Popover>
            )}
        >
            <a href={settings.url} onClick={settings.onClick} {...settings.linkAttributes}>{child}</a>
        </OverlayTrigger>
    ),
    serialize: (child, settings) => `<a href="${DOMPurify().sanitize(settings.url ?? "")}">${child}</a>`,
    deserialize: (children, settings, options) => jsx("text", {
        ...children,
        [StyleType.LINK]: {
            url: settings?.getAttribute("href"),
            onClick: options?.onLinkClicked,
            linkAttributes: options?.linkAttributes?.(settings?.getAttribute("href") as string | undefined),
        },
    }),
    apply: (props: LinkSettings) => ({
        url: props.url,
    }),
} as ElementRenderer<LinkSettings> & BlockDeserializer<TextElement>);
